<div class="row mt-3">
  <h2>{{ license.STATE_NAME }}</h2>
  @if (license.BROKER_CONTACT_NAME) {
    <div class="col-12 col-lg-4">
      <h3 class="h5"><strong>Broker</strong></h3>
      <p>
        {{ license.BROKER_CONTACT_NAME }}<br />
        License #: {{ license.BROKER_LICENSE_NUMBER }}
      </p>
      <p>
        {{ license.BROKER_COMPANY_NAME }}<br />
        License #: {{ license.BROKER_COMPANY_LICENSE_NUMBER }}
      </p>
    </div>
  }
  @if (license.BROKER_CONTACT_NAME && (license.AUCTIONEER_NAME || license.AUCTION_COMPANY_NAME)) {
    <p-divider
      layout="vertical"
      class="col g-0 flex-grow-0 d-none d-xxl-flex" />
  }
  @if (license.AUCTIONEER_NAME || license.AUCTION_COMPANY_NAME) {
    <div class="col-12 col-lg-4">
      <h3 class="h5"><strong>Auctioneer</strong></h3>
      @if (license.AUCTIONEER_NAME) {
        <p>
          {{ license.AUCTIONEER_NAME }}<br />
          License #: {{ license.AUCTIONEER_LICENSE_NUMBER }}
        </p>
      }
      @if (license.AUCTION_COMPANY_NAME) {
        <p>
          {{ license.AUCTION_COMPANY_NAME }}<br />
          License #: {{ license.AUCTION_COMPANY_LICENSE_NUMBER }}
        </p>
      }
    </div>
  }
  @if (
    (license.AUCTIONEER_NAME || license.BROKER_CONTACT_NAME) &&
    license.PRIVATE_SELLING_OFFICER_NAME &&
    license.PRIVATE_SELLING_OFFICER_AUCTIONEER_LICENSE_NUMBER
    ) {
    <p-divider
      layout="vertical"
      class="col g-0 flex-grow-0 d-none d-xxl-flex" />
  }
  @if (license.PRIVATE_SELLING_OFFICER_NAME && license.PRIVATE_SELLING_OFFICER_AUCTIONEER_LICENSE_NUMBER) {
    <div class="col-12 col-lg-3">
      <h3 class="h5"><strong>Private Selling Officer</strong></h3>
      <p class="mb-0">{{ license.PRIVATE_SELLING_OFFICER_NAME }}</p>
      @if (license.PRIVATE_SELLING_OFFICER_CITY && license.PRIVATE_SELLING_OFFICER_STATE) {
        <p>
          {{ license.PRIVATE_SELLING_OFFICER_CITY }}, {{ license.PRIVATE_SELLING_OFFICER_STATE }}
        </p>
      }
      <p class="mb-0"><span>Auctioneer License #: </span>{{ license.PRIVATE_SELLING_OFFICER_AUCTIONEER_LICENSE_NUMBER }}</p>
      <p class="mb-0"><span>Salesperson or Broker License #: </span>{{ license.PRIVATE_SELLING_OFFICER_BROKER_LICENSE_NUMBER }}</p>
    </div>
  }
</div>
